import { ContentItemObject, ContentType } from '../../ContentManagementProvider/Context'
import ContentEditModal from './ContentEditModal'
import ContentModalProvider from './ContentModalProvider'

export type ContentModalProps = {
  show: boolean
  onHide: () => void
  contentItem: ContentItemObject
  type?: ContentType
  mode?: 'edit' | 'copy' | 'new'
}

const ContentModal = (props: ContentModalProps) => {
  return (
    <ContentModalProvider {...props}>
      <ContentEditModal />
    </ContentModalProvider>
  )
}

export default ContentModal
